module.exports = {
  adverseTerm:  (Api, $stateParams) ->
    if $stateParams.adverseId
      return Api.AdverseTerms.get(id: $stateParams.adverseId).$promise
  adverseTermsLists:  (Api) ->
    return Api.AdverseTerms.query().$promise
  languages: (Api) ->
    return Api.Language.query().$promise
}
